import { env } from '../env';

export const devServer = "dev-back-end.3win.app";
export const testServer = "test-back-end.3win.app";
export const prodServer = "prod-back-end.3win.app";

const hostDomain = "3win.app";
const hostname = env === "local"
  ? window.location.hostname
  : env === "dev"
  ? devServer
  : env === "test"
  ? testServer
  : env === "prod"
  ? prodServer
  : `${env}.${hostDomain}`;
const port = env === "local" ? 8080 : 443;
const https = env !== "local" || window.location.protocol === "https:";
const pathname = "";

export const serverConfig = {
  hostname,
  port,
  https,
  pathname,

  // For hosting with the same hostname, assuming backend is port forwarded to external port 8080 and https, use below
  // hostname: window.location.hostname,
  // port: 8080,
  // https: window.location.protocol.match(/https/g),

  defaultHeaders: {
    Authorization: `Basic ${btoa("app3win:app3win")}`
  },
};

export const oauthClientId = "app3win";

export const serverPortString =
  serverConfig.port.toString().match(/^80$|^443$/g)
    ? ""
    : `:${serverConfig.port}`;

export const serverHostnameString = `${
  serverConfig.https ? "https://" : "http://"
  }${serverConfig.hostname}${serverPortString}${serverConfig.pathname}`;

export const baseURL = serverHostnameString;